import React from 'react';
import { Link } from 'react-router-dom';
import { Database } from 'lucide-react';

/**
 * "Public Property" link on a seller lead (DOMA 13321183498).
 *
 * A seller lead whose address is already in an agent's Database carries that
 * row as `database_record` ({ id, url }). The API only sends it to someone who
 * can open the row, so a missing record simply shows nothing. A real link, so
 * it can be opened in a new tab, and it never also opens the row it sits in.
 */
const PublicPropertyLink = ({ record, className = '' }) => {
  if (!record?.id) return null;
  return (
    <Link
      to={record.url || `/public-properties/${record.id}`}
      onClick={(e) => e.stopPropagation()}
      title="Open the Public Property at this address"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-indigo-50 text-indigo-600 border border-indigo-100 hover:bg-indigo-100 whitespace-nowrap ${className}`}
    >
      <Database className="w-3 h-3" />
      Public Property
    </Link>
  );
};

export default PublicPropertyLink;
